import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { getOrCreateGlobalStore } from '@adsk/alloy-react-context';

import type { LaunchDarklyContextValue } from '../LaunchDarklyContext';
import type { EntitlementsUser } from '../projectEntitlementTypes';

export type AlloyLaunchDarklyStore = {
  user?: EntitlementsUser;
  projectId?: string;
  accountId?: string;
  ldContextValue?: LaunchDarklyContextValue;
  setUser: (user?: EntitlementsUser) => void;
  setProjectId: (projectId?: string) => void;
  setAccountId: (accountId?: string) => void;
  setLdContextValue: (value?: LaunchDarklyContextValue) => void;
};

export const useAlloyLaunchDarklyStore = () =>
  getOrCreateGlobalStore<AlloyLaunchDarklyStore>(
    (set, get) => ({
      user: undefined,
      projectId: undefined,
      accountId: undefined,
      ldContextValue: undefined,
      setUser: (newUser?: EntitlementsUser) => {
        if (newUser !== get().user) {
          set({ user: newUser });
        }
      },
      setProjectId: (newProjectId?: string) => {
        if (newProjectId !== get().projectId) {
          set({ projectId: newProjectId });
        }
      },
      setAccountId: (newAccountId?: string) => {
        if (newAccountId !== get().accountId) {
          set({ accountId: newAccountId });
        }
      },
      setLdContextValue: (newValue?: LaunchDarklyContextValue) => {
        if (newValue !== get().ldContextValue) {
          set({ ldContextValue: newValue });
        }
      },
    }),
    CONTEXT_NAMES.AlloyLaunchDarklyContext,
  )();
